/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE", "EXPERIMENTAL_OVERRIDE")

package features.userBusinessNotifications.internal

import features.userBusinessNotifications.models.UserBusinessNotificationsModel
import kangaroorewards.appsdk.core.domain.Result
import kangaroorewards.appsdk.core.io.toModel

internal class UserBusinessNotificationsServiceImpl : UserBusinessNotificationsService {

    private val userBusinessNotificationsRequest = UserBusinessNotificationsRequest()

    override suspend fun getUserBusinessNotifications(
        overrideHeaders : Map<String, String>?,
        businessId: String    ): Result<UserBusinessNotificationsModel> {
        return userBusinessNotificationsRequest.getUserBusinessNotifications(
            overrideHeaders = overrideHeaders,
            businessId = businessId        ).toModel()
    }
}
